// src/screens/crew/CrewScreen.js
// 74차: 신규 생성 — 크루 메인 화면. 크루가 없으면 둘러보기/만들기, 있으면 크루
// 정보 + 게시판(댓글형 피드)을 보여준다.
// v1 범위 안내(ponytail): "테마 추천"은 이 화면 안의 간단한 검색으로, "탈출기록 공유"는
// 내 리뷰 중 하나를 골라 텍스트 요약으로 공유하는 방식으로 단순화했다 — 실시간 채팅이나
// EscapeDashboardScreen의 이미지 카드 생성까지는 이번 범위에 넣지 않음(필요해지면 확장).
// 75차: 비회원 전면 차단 제거 — 둘러보기(BrowseCrews)는 비회원에게도 열어두고, 가입
// 신청/크루 만들기 등 실제 행동만 로그인으로 유도. 크루 카드에 크루장 닉네임 표시
// (crew.ownerNickname 스냅샷, crewService.js).
// 75차: 테마 추천 게시글 카드화 — 검색해서 고르는 것 자체는 이미 되고 있었음
// (ThemeRecommendModal), 다만 피드에 텍스트 한 줄로만 나오던 것을 썸네일+매장명+장르+
// 가격이 보이는 카드로 교체(addCrewThemeRecommend가 저장하는 스냅샷 필드 사용).
// 77차: design 폴더 크루 게시판 화면 스펙 적용 — 크루 정보 바를 배너 카드(엠블럼 타일)로,
// 게시글 카드 4종(메시지/테마추천/탈출기록/모집연동)에 타입별 컬러 아이콘 사각형 추가.
// 스펙의 "함께 탈출/성공률/이번 주 모임" 3-스탯 행은 crews 문서에 해당 필드가 없어(가입자
// 수만 있음) 생략 — 데이터 없는 수치를 지어내지 않음.
// 78차: 크루 만들기/가입 신청/관리/테마추천·기록공유/전송/모달 취소 버튼을 공용
// GradientButton/SecondaryButton/TextButton으로 교체

import React, { useState, useCallback, useEffect, useMemo, useRef } from 'react';
import { showAlert } from '../../components/common/AppAlert';
import {
  View, Text, TextInput, TouchableOpacity, Pressable, StyleSheet,
  FlatList, ScrollView, ActivityIndicator, KeyboardAvoidingView, Platform, Modal,
} from 'react-native';
// 78차 37차: 썸네일 캐싱 없이 매번 재다운로드되던 것 — expo-image로 교체(디스크 캐시 자동)
import { Image } from 'expo-image';
import * as ImagePicker from 'expo-image-picker';
import * as ImageManipulator from 'expo-image-manipulator';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../services/firebase';
import { useFocusEffect } from '@react-navigation/native';
import { useAuth } from '../../contexts/AuthContext';
import AppHeader from '../../components/common/AppHeader';
import GradientButton from '../../components/common/GradientButton';
import { SecondaryButton } from '../../components/common/Buttons';
import {
  CheckmarkIcon, PeopleIcon, IconLabel, ThemeRecommendIcon, ClockIcon, ReportFlagIcon,
  CrewMessageIcon, CrewRecruitLinkIcon, CrewNoticeIcon, CrewEmblemIcon,
  EscapeRecordSuccessIcon, EscapeRecordFailIcon, HintUsageIcon, AdminIcon,
  NoEntryIcon, CrownIcon, CameraIcon,
  RankMedalGoldIcon, RankMedalSilverIcon, RankMedalBronzeIcon, TrophyIcon,
} from '../../components/common/Icons';

import { COLORS } from '../../constants/theme';
import { getGenreMeta, getSeatingTypeLabel } from '../../constants';
import {
  getMyCrew, listBrowsableCrews, listTopCrews, requestJoinCrew, cancelJoinRequest,
  listenCrewPosts, addCrewMessage, addCrewThemeRecommend, addCrewEscapeShare,
  getCrewCap, getCrewLevel, reportCrewPost, CREW_TAG_GROUPS,
  getCrewMemberProfilesCF, parseMentions,
} from '../../services/crewService';
// 78차 66차: 테마추천 카드에 사업자명만 나오던 것 → 지점명까지 합쳐서 표시(다른 화면과
// 동일한 "{사업자명} {지점명}" 표기 관례).
const fullStoreName = (storeName, branchName) => [storeName, branchName].filter(Boolean).join(' ');

// 80차 계속: 크루 랭킹 1/2/3위만 메달 아이콘, 그 외는 "N위" 텍스트 — BrowseCrews와
// CrewRankingModal 둘 다에서 재사용. 두 분기 다 View로 감싸 justifyContent:'center'를
// 직접 지정 — Text를 맨몸으로 두면 폰트 메트릭(줄높이)이 아이콘 높이와 안 맞아
// row(alignItems:'center') 안에서 미묘하게 아래로 처져 보이는 버그가 있었음(스크린샷으로
// 재신고 — 4위 텍스트만 크루명보다 낮게 보임).
const RANK_MEDALS = [RankMedalGoldIcon, RankMedalSilverIcon, RankMedalBronzeIcon];
function RankBadge({ index }) {
  const Medal = RANK_MEDALS[index];
  return (
    <View style={{ width: 32, alignItems: 'flex-start', justifyContent: 'center' }}>
      {Medal ? <Medal size={20} /> : <Text style={{ fontSize: 13, fontWeight: '700', color: COLORS.textMuted }}>{index + 1}위</Text>}
    </View>
  );
}

// 78차 72차: 탈출기록 공유 문구를 축하하는 톤으로 — "OO분 남기고 탈출 성공!"(제한시간 대비
// 잔여시간, EscapeDashboardScreen.js의 parseTimeToSeconds와 동일한 파싱 로직) +
// 인원수(크루원과 함께한 느낌, reservations.people 재사용 — 이 앱엔 "동행한 크루원"을
// 따로 기록하는 필드가 없어 예약 인원수로 대체).
const parseEscapeTimeToMinutes = (t) => {
  if (!t || typeof t !== 'string') return null;
  if (/^\d+분$/.test(t.trim())) return parseInt(t, 10);
  const p = t.split(':').map(Number);
  if (p.length === 2) return Math.round(p[0] + p[1] / 60);
  if (p.length === 3) return Math.round(p[0] * 60 + p[1] + p[2] / 60);
  return null;
};
const buildEscapeShareText = (reservation) => {
  const peopleNum = parseInt(reservation.people, 10);
  const peopleLabel = peopleNum > 1 ? ` (${peopleNum}명이서 함께)` : '';
  if (!reservation.success) return `${reservation.productName} · 탈출 실패 😭 다음엔 꼭!${peopleLabel}`;

  const durationMin = Number(reservation.duration) || null;
  const usedMin = parseEscapeTimeToMinutes(reservation.escapeTime);
  let timeLabel = '';
  if (durationMin != null && usedMin != null) {
    timeLabel = ` · ${Math.max(0, durationMin - usedMin)}분 남기고`;
  } else if (usedMin != null) {
    timeLabel = ` · ${usedMin}분 만에`;
  }
  return `${reservation.productName}${timeLabel} 탈출 성공! 🎉${peopleLabel}`;
};
// 80차 후속: 체험형은 성공/실패 개념이 없어 "탈출 기록" 대신 "재밌으니 보라"는 추천 문구로
const buildShowShareText = (reservation) => {
  const peopleNum = parseInt(reservation.people, 10);
  const peopleLabel = peopleNum > 1 ? ` (${peopleNum}명이서 함께)` : '';
  return `${reservation.productName} 다녀왔어요, 재밌으니까 한 번 보세요!${peopleLabel}`;
};
import { getAllProducts, normalizeProduct, getProductById } from '../../services/productService';
import { isConfirmedMinorBirth } from '../../utils/dateUtils';
import { getMyReviews } from '../../services/reviewService';
import { getMyReservations } from '../../services/reservationService';
import { blockUser } from '../../services/blockService';
import { markNotificationsReadByType } from '../../services/recruitService';

const GOLD       = COLORS.gold;
const BG         = COLORS.bg;
const SURFACE    = COLORS.surface;
const SURFACE2   = COLORS.surface2;
const BORDER     = COLORS.border;
const TEXT       = COLORS.text;
const TEXT_SEC   = COLORS.textSec;
const TEXT_MUTED = COLORS.textMuted;
const ON_GOLD    = COLORS.onGold;

// ─── 크루 없을 때: 둘러보기 + 만들기 ─────────────────────────
function BrowseCrews({ navigation, uid, myPendingCrewIds, onRequestJoin, isLoggedIn = true }) {
  const [crews, setCrews] = useState([]);
  const [topCrews, setTopCrews] = useState([]);
  const [loading, setLoading] = useState(true);
  // 80차 계속: 크루 없는 사람이 "나랑 맞는 크루" 찾기 — 크루 생성 시 고르는 태그
  // (CREW_TAG_GROUPS)로 둘러보기 목록을 좁힘. 선택한 태그를 전부 가진 크루만(AND) 노출.
  const [filterTags, setFilterTags] = useState([]);
  const [filterExpanded, setFilterExpanded] = useState(false);
  const toggleFilterTag = (t) => setFilterTags(prev => prev.includes(t) ? prev.filter(x => x !== t) : [...prev, t]);
  const filteredCrews = useMemo(() => {
    if (filterTags.length === 0) return crews;
    return crews.filter(c => filterTags.every(t => (c.tags || []).includes(t)));
  }, [crews, filterTags]);
  // 79차: 탭을 빠르게 오가면 이전 포커스의 load()가 늦게 응답해 최신 목록을 오래된
  // 것으로 덮어쓸 수 있었음 — activeRef로 이전 포커스 세션의 setState만 무시.
  const activeRef = useRef(true);

  const load = useCallback(async () => {
    try {
      const list = await listBrowsableCrews();
      if (activeRef.current) setCrews(list);
    }
    catch { if (activeRef.current) setCrews([]); }
    finally { if (activeRef.current) setLoading(false); }
    // 80차 계속: 랭킹은 둘러보기 목록과 별개 쿼리라 실패해도(느린 네트워크 등) 위 목록
    // 표시를 막지 않도록 독립적으로 처리 — 실패 시 섹션 자체를 숨김(빈 배열).
    listTopCrews(5).then(list => { if (activeRef.current) setTopCrews(list); }).catch(() => {});
  }, []);
  useFocusEffect(useCallback(() => {
    activeRef.current = true;
    load();
    return () => { activeRef.current = false; };
  }, [load]));

  return (
    <ScrollView contentContainerStyle={{ padding: 16, paddingBottom: 40 }}>
      <View style={s.introCard}>
        <IconLabel Icon={PeopleIcon} size={16} color={TEXT} textStyle={s.introTitle}>크루로 같이 탈출하세요</IconLabel>
        <Text style={s.introDesc}>
          친한 사람들끼리 모여 테마를 추천하고, 같이 진행하고, 팀원을 모집해보세요.
        </Text>
        <GradientButton
          label="+ 크루 만들기"
          onPress={() => navigation.navigate(isLoggedIn ? 'CreateCrew' : 'Login')}
          style={s.createBtn}
          textStyle={s.createBtnText}
        />
      </View>

      {topCrews.length > 0 && (
        <>
          <IconLabel Icon={TrophyIcon} size={s.sectionLabel.fontSize || 13} color={s.sectionLabel.color} textStyle={s.sectionLabel}>크루 랭킹</IconLabel>
          <View style={s.introCard}>
            {topCrews.map((crew, idx) => (
              <View key={crew.id} style={{ flexDirection: 'row', alignItems: 'center', gap: 10, paddingVertical: 7 }}>
                <RankBadge index={idx} />
                <Text style={{ flex: 1, fontSize: 13, color: TEXT, fontWeight: '600' }} numberOfLines={1}>{crew.name}</Text>
                <Text style={{ fontSize: 12, color: TEXT_MUTED }}>Lv.{crew.level} · {(crew.memberUids || []).length}명</Text>
              </View>
            ))}
          </View>
        </>
      )}

      <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
        <Text style={[s.sectionLabel, { marginBottom: 0 }]}>크루 둘러보기</Text>
        <TouchableOpacity onPress={() => setFilterExpanded(v => !v)}>
          <Text style={{ color: filterTags.length > 0 ? GOLD : TEXT_MUTED, fontSize: 12, fontWeight: '700' }}>
            🔍 필터{filterTags.length > 0 ? ` (${filterTags.length})` : ''} {filterExpanded ? '▲' : '▼'}
          </Text>
        </TouchableOpacity>
      </View>

      {filterExpanded && (
        <View style={[s.introCard, { marginTop: -2 }]}>
          {CREW_TAG_GROUPS.map(group => (
            <View key={group.key} style={{ marginBottom: 10 }}>
              <Text style={{ color: TEXT_MUTED, fontSize: 11, marginBottom: 6 }}>{group.label}</Text>
              <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 6 }}>
                {group.tags.map(t => (
                  <TouchableOpacity key={t} onPress={() => toggleFilterTag(t)}
                    style={[s.tagChip, filterTags.includes(t) && s.tagChipActive]}>
                    <Text style={[s.tagChipText, filterTags.includes(t) && s.tagChipTextActive]}>{t}</Text>
                  </TouchableOpacity>
                ))}
              </View>
            </View>
          ))}
          {filterTags.length > 0 && (
            <TouchableOpacity onPress={() => setFilterTags([])} style={{ alignSelf: 'flex-start' }}>
              <Text style={{ color: TEXT_MUTED, fontSize: 12, textDecorationLine: 'underline' }}>필터 초기화</Text>
            </TouchableOpacity>
          )}
        </View>
      )}

      {loading ? <ActivityIndicator color={GOLD} style={{ marginTop: 20 }} /> : (
        filteredCrews.length === 0 ? (
          <View style={{ alignItems: 'center' }}>
            <Text style={s.emptyText}>{crews.length === 0 ? '아직 만들어진 크루가 없어요.' : '조건에 맞는 크루가 없어요.'}</Text>
            {/* 80차 계속: RecruitScreen.js의 빈 상태 CTA 패턴과 동일 — 모집 목록은
                이미 "첫 모집 글 작성하기" 유인이 있는데 크루 목록만 텍스트뿐이라 비대칭
                이었음(신규유저 유입 감사에서 발견). 상단 "+ 크루 만들기"가 이미 있지만
                텅 빈 상태를 실제로 마주친 지점에도 다시 한번 행동을 유도. */}
            {crews.length === 0 && (
              <TouchableOpacity
                style={{ marginTop: 12, paddingVertical: 10, paddingHorizontal: 20, borderRadius: 10, borderWidth: 1, borderColor: 'rgba(216,174,82,0.5)' }}
                onPress={() => navigation.navigate(isLoggedIn ? 'CreateCrew' : 'Login')}>
                <Text style={{ color: GOLD, fontSize: 13, fontWeight: '700' }}>첫 크루 만들어보기</Text>
              </TouchableOpacity>
            )}
          </View>
        ) : filteredCrews.map(crew => {
          const memberCount = (crew.memberUids || []).length;
          const crewCap = getCrewCap(crew);
          const isFull = memberCount >= crewCap;
          const isPending = myPendingCrewIds.includes(crew.id);
          return (
            <View key={crew.id} style={s.crewCard}>
              {/* 80차 계속: 크루 대표사진 — 크루 관리 화면에서 이미 설정 가능한 crew.imageUrl을
                  이 둘러보기 카드에도 반영(그동안 크루방 안에서만 보이고 여기선 빠져있었음) */}
              <View style={s.crewEmblem}>
                {crew.imageUrl
                  ? <Image source={{ uri: crew.imageUrl }} style={s.crewEmblemImg} />
                  : <CrewEmblemIcon size={26} />}
              </View>
              <View style={{ flex: 1 }}>
                <Text style={s.crewCardName}>{crew.name}</Text>
                {!!crew.ownerNickname && <IconLabel Icon={CrownIcon} size={s.crewCardOwner.fontSize || 12} color={s.crewCardOwner.color} textStyle={s.crewCardOwner}>{crew.ownerNickname}</IconLabel>}
                {!!crew.description && <Text style={s.crewCardDesc} numberOfLines={2}>{crew.description}</Text>}
                {crew.tags?.length > 0 && (
                  <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 6, marginTop: 6 }}>
                    {crew.tags.map(t => (
                      <View key={t} style={s.tagChip}><Text style={s.tagChipText}>{t}</Text></View>
                    ))}
                  </View>
                )}
                <Text style={s.crewCardMembers}>{memberCount}/{crewCap}명</Text>
              </View>
              <GradientButton
                label={isPending ? '신청됨' : isFull ? '정원 마감' : '가입 신청'}
                disabled={isFull || isPending}
                onPress={() => onRequestJoin(crew.id)}
                style={s.joinBtn}
                textStyle={s.joinBtnText}
              />
            </View>
          );
        })
      )}
    </ScrollView>
  );
}

// ─── 테마 추천 검색 모달 ──────────────────────────────────────
// 77차: (1) autoFocus 제거 — 버튼 누르자마자 키보드가 튀어나오던 것 수정.
// (2) 검색어가 비어있을 때 "내가 완료한 테마"(getMyReviews, EscapeShareModal과 동일 데이터
// 소스 재사용)를 기본으로 보여줌 — "최근 본 테마"는 이 앱에 조회 이력을 유저별로 남기는
// 기능 자체가 없어(조회수는 테마당 합산치만 있음, 55차) 지어내지 않고, 실제로 있는 데이터인
// "완료한 테마"로 대체. all(이미 로드된 전체 상품)에서 productId로 찾아 검색 결과와 동일한
// 형태(정식 product 객체)로 맞춰 onPick에 넘김 — 리뷰 문서 그대로 넘기면 normalizeProduct가
// 기대하는 필드(pricing/genre/imageUrl 등)가 없어 깨짐.
// (3) 시트 높이를 화면의 절반 정도로 고정(modalSheetTall) — 기존엔 내용 크기만큼만 잡혀
// 입력만 있을 때 너무 작아 보였음.
// 78차: (1) 좌하단 "닫기" 버튼 제거 — 시트 바깥(백드롭) 탭으로 닫도록 변경, 시트 자체를
// 누르면 안 닫히게 Pressable로 탭 전파 차단. (2) 완료한 테마가 하나도 없으면 그냥 "검색해
// 보라"는 안내만 있어 막막했던 것 — 검색 전에도 전체 테마 목록을 바로 둘러볼 수 있게
// 폴백 추가. (3) 테마를 고르면 바로 게시판에 올라가던 것 → 선택 시 확인 화면을 한 번
// 거치도록 변경(게시하기/다시 선택).
function ThemeRecommendModal({ visible, onClose, onPick, uid, isMinor = false }) {
  const [keyword, setKeyword] = useState('');
  const [all, setAll] = useState([]);
  const [recentReviews, setRecentReviews] = useState([]);
  const [selected, setSelected] = useState(null);
  // 80차 후속: 확인된 미성년자에게 19금 테마 추천 목록 노출 차단
  useEffect(() => { if (visible) getAllProducts({ isMinor }).then(setAll).catch(() => setAll([])); }, [visible, isMinor]);
  useEffect(() => {
    if (!visible) { setKeyword(''); setSelected(null); }
    if (!visible || !uid) { setRecentReviews([]); return; }
    getMyReviews(uid).then(reviews => {
      const seen = new Set();
      const deduped = reviews.filter(r => {
        if (!r.productId || seen.has(r.productId)) return false;
        seen.add(r.productId); return true;
      });
      setRecentReviews(deduped.slice(0, 10));
    }).catch(() => setRecentReviews([]));
  }, [visible, uid]);

  const results = useMemo(() => {
    const kw = keyword.trim().toLowerCase();
    if (!kw) return [];
    return all.filter(p => normalizeProduct(p).name?.toLowerCase().includes(kw)).slice(0, 15);
  }, [keyword, all]);

  const completedProducts = useMemo(() => {
    if (!all.length || !recentReviews.length) return [];
    return recentReviews.map(r => all.find(p => p.id === r.productId)).filter(Boolean);
  }, [all, recentReviews]);

  const searching = keyword.trim().length > 0;
  // 78차: 완료한 테마가 없으면 검색 전에도 둘러볼 수 있게 전체 테마를 폴백으로 노출
  const browsing = !searching && completedProducts.length === 0;
  const listData = searching ? results : (completedProducts.length > 0 ? completedProducts : all.slice(0, 30));
  const sectionLabel = searching ? null : (completedProducts.length > 0 ? '내가 완료한 테마' : '전체 테마 (검색으로 좁혀보세요)');

  const selectedNorm = selected ? normalizeProduct(selected) : null;

  return (
    <Modal visible={visible} animationType="slide" transparent onRequestClose={onClose}>
      <Pressable style={s.modalBackdrop} onPress={onClose}>
        <Pressable style={[s.modalSheet, s.modalSheetTall]} onPress={() => {}}>
          {selectedNorm ? (
            <>
              <Text style={s.modalTitle}>이 테마를 추천할까요?</Text>
              <View style={s.confirmThemeRow}>
                {selectedNorm.thumbnailUrl
                  ? <Image source={{ uri: selectedNorm.thumbnailUrl }} style={s.themeCardThumb} />
                  : <View style={[s.themeCardThumb, s.themeCardThumbPlaceholder]}><CrewEmblemIcon size={22} color="#5a5a68" /></View>}
                <View style={{ flex: 1, gap: 3 }}>
                  <Text style={s.themeCardName} numberOfLines={1}>{selectedNorm.name}</Text>
                  {!!selectedNorm.storeName && <Text style={s.themeCardStore} numberOfLines={1}>{fullStoreName(selectedNorm.storeName, selectedNorm.branchName)}</Text>}
                </View>
              </View>
              <View style={{ flexDirection: 'row', gap: 8, marginTop: 14 }}>
                <SecondaryButton label="다시 선택" onPress={() => setSelected(null)} style={{ flex: 1 }} />
                <GradientButton label="게시하기" onPress={() => onPick(selected)} style={{ flex: 1 }} />
              </View>
            </>
          ) : (
            <>
              <Text style={s.modalTitle}>테마 추천하기</Text>
              <TextInput
                style={s.modalInput} value={keyword} onChangeText={setKeyword}
                placeholder="테마 이름 검색" placeholderTextColor={TEXT_MUTED}
              />
              {sectionLabel && <Text style={s.modalSectionLabel}>{sectionLabel}</Text>}
              <FlatList
                data={listData} keyExtractor={item => String(item.id)}
                style={{ flex: 1 }}
                ListEmptyComponent={
                  browsing ? <Text style={s.emptyText}>등록된 테마가 없어요.</Text> : null
                }
                renderItem={({ item }) => {
                  // 78차 35차: 이름/매장명 텍스트 두 줄뿐이라 게시된 후의 카드(썸네일+장르+
                  // 가격)와 비교해 밋밋하다는 피드백 — 선택 단계부터 동일한 톤으로 통일해
                  // 가독성 개선(게시 후 어떤 모습일지 미리 보여주는 효과도 있음).
                  const np = normalizeProduct(item);
                  const gm = np.genre ? getGenreMeta(np.genre) : null;
                  return (
                    <TouchableOpacity style={s.modalResultRow} onPress={() => setSelected(item)}>
                      <View style={s.themeCardRow}>
                        {np.thumbnailUrl
                          ? <Image source={{ uri: np.thumbnailUrl }} style={s.themeCardThumb} />
                          : <View style={[s.themeCardThumb, s.themeCardThumbPlaceholder]}><CrewEmblemIcon size={22} color="#5a5a68" /></View>}
                        <View style={{ flex: 1, gap: 3 }}>
                          <Text style={s.themeCardName} numberOfLines={1}>{np.name}</Text>
                          {!!np.storeName && <Text style={s.themeCardStore} numberOfLines={1}>{fullStoreName(np.storeName, np.branchName)}</Text>}
                          <View style={{ flexDirection: 'row', alignItems: 'center', gap: 6 }}>
                            {gm && (
                              <View style={[s.themeCardGenreChip, { backgroundColor: gm.color + '26', borderColor: gm.color + '59' }]}>
                                <Text style={[s.themeCardGenreText, { color: gm.color }]}>{np.genre}</Text>
                              </View>
                            )}
                            {np.price != null && <Text style={s.themeCardPrice}>{Number(np.price).toLocaleString()}원~</Text>}
                          </View>
                        </View>
                      </View>
                    </TouchableOpacity>
                  );
                }}
              />
            </>
          )}
        </Pressable>
      </Pressable>
    </Modal>
  );
}

// ─── 탈출기록 공유 선택 모달 ──────────────────────────────────
// 78차: 좌하단 "닫기" 버튼 제거 — 시트 바깥(백드롭) 탭으로 닫도록 변경
// 78차 66차: 데이터 소스를 "내가 쓴 리뷰"(getMyReviews) → "매장이 성공/실패를 입력한
// 내 예약"(getMyReservations, success!=null)으로 교체 — 기존엔 리뷰를 먼저 써야만
// 목록에 떴는데, 매장이 결과입력만 하고 리뷰는 아직 안 쓴 예약(사용자가 신고한
// "성공처리했는데 목록에 안 나옴" 케이스)이 통째로 빠져있었음.
// 78차 69차: 고르자마자 바로 게시되던 것 → ThemeRecommendModal과 동일한 선택→확인
// 2단계로 변경(어떤 모습으로 공유될지 미리 안 보인다는 신고) + 힌트 횟수/소요 시간처럼
// 매장이 이미 입력해둔 "자랑거리" 데이터를 미리보기·실제 게시글에 함께 노출.
function EscapeShareModal({ visible, onClose, uid, crewId, onPick }) {
  const [records, setRecords] = useState([]);
  const [selected, setSelected] = useState(null);
  // 80차 계속: 탈출 인증샷 — room 포맷(실제 성공/실패가 있는 방탈출)에만 노출. show는
  // 이미 테마 자체 이미지를 쓰고 있어 대상 아님. 선택 즉시 업로드(취소해도 고아 파일
  // 1개 남는 정도는 다른 게시글 타입의 기존 정책과 동일 수준이라 감수).
  const [photoUrl, setPhotoUrl] = useState(null);
  const [photoUploading, setPhotoUploading] = useState(false);
  useEffect(() => {
    if (!visible || !uid) return;
    // 80차 후속: 체험형은 success가 항상 null이라 이전엔 목록에서 통째로 빠져있었음
    // (탈출기록 공유 자체가 불가능했음) — 이미 지나간 체험형 예약도 선택 가능하게 포함.
    const now = new Date();
    const isOccurredShow = (r) => r.bookingFormat === 'show' && r.cancelled !== true
      && new Date(`${r.date}T${r.time || '00:00'}`) <= now;
    getMyReservations(uid)
      .then(list => setRecords(list.filter(r => r.success === true || r.success === false || isOccurredShow(r))))
      .catch(() => setRecords([]));
  }, [visible, uid]);
  useEffect(() => { if (!visible) { setSelected(null); setPhotoUrl(null); } }, [visible]);

  const pickPhoto = async () => {
    const { status } = await ImagePicker.requestMediaLibraryPermissionsAsync();
    if (status !== 'granted') { showAlert('알림', '사진 접근 권한이 필요해요.'); return; }
    const result = await ImagePicker.launchImageLibraryAsync({ mediaTypes: ImagePicker.MediaTypeOptions.Images, quality: 0.8 });
    if (result.canceled) return;
    setPhotoUploading(true);
    try {
      const compressed = await ImageManipulator.manipulateAsync(
        result.assets[0].uri, [{ resize: { width: 800 } }],
        { compress: 0.8, format: ImageManipulator.SaveFormat.JPEG }
      );
      const blob = await new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.onload = () => resolve(xhr.response);
        xhr.onerror = () => reject(new Error('이미지 로드 실패'));
        xhr.responseType = 'blob';
        xhr.open('GET', compressed.uri, true);
        xhr.send(null);
      });
      const imageBase64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result.split(',')[1]);
        reader.onerror = () => reject(new Error('이미지 인코딩 실패'));
        reader.readAsDataURL(blob);
      });
      blob.close && blob.close();
      const uploadCF = httpsCallable(functions, 'uploadCrewEscapePhotoCF');
      const { data } = await uploadCF({ crewId, imageBase64, contentType: 'image/jpeg' });
      setPhotoUrl(data.url);
    } catch { showAlert('오류', '사진 업로드에 실패했어요.'); }
    finally { setPhotoUploading(false); }
  };

  return (
    <Modal visible={visible} animationType="slide" transparent onRequestClose={onClose}>
      <Pressable style={s.modalBackdrop} onPress={onClose}>
        <Pressable style={s.modalSheet} onPress={() => {}}>
          {selected ? (
            <>
              <Text style={s.modalTitle}>{selected.bookingFormat === 'show' ? '이 관람을 추천할까요?' : '이 기록을 공유할까요?'}</Text>
              <View style={s.escapePreviewCard}>
                <View style={{ flexDirection: 'row', alignItems: 'center', gap: 8 }}>
                  {selected.bookingFormat === 'show'
                    ? <CheckmarkIcon size={20} color={COLORS.blue} />
                    : (selected.success ? <EscapeRecordSuccessIcon size={20} /> : <EscapeRecordFailIcon size={20} />)}
                  <Text style={[s.themeCardName, { flex: 1 }]} numberOfLines={1}>{selected.productName}</Text>
                </View>
                <Text style={[s.themeCardStore, { marginTop: 6 }]}>
                  {selected.bookingFormat === 'show' ? buildShowShareText(selected) : buildEscapeShareText(selected)}
                </Text>
                {selected.bookingFormat !== 'show' && (selected.escapeTime || selected.hintCount != null) && (
                  <View style={{ flexDirection: 'row', gap: 14, marginTop: 8 }}>
                    {selected.escapeTime && <IconLabel Icon={ClockIcon} size={12} color={GOLD} textStyle={s.themeCardStore}>{selected.escapeTime}</IconLabel>}
                    {selected.hintCount != null && <IconLabel Icon={HintUsageIcon} size={12} color={s.themeCardStore.color} textStyle={s.themeCardStore}>힌트 {selected.hintCount}회</IconLabel>}
                  </View>
                )}
              </View>

              {/* 80차 계속: 탈출 인증샷 — 실제 완료한 예약을 고른 다음에만 붙일 수 있는
                  사진이라, 함부로 지어낼 수 없는 "진짜 인증" 성격을 가짐. room 포맷만
                  대상(show는 이미 테마 이미지를 씀). */}
              {selected.bookingFormat !== 'show' && (
                photoUrl ? (
                  <View style={{ marginTop: 12 }}>
                    <Image source={{ uri: photoUrl }} style={{ width: '100%', height: 160, borderRadius: 12 }} />
                    <TouchableOpacity onPress={pickPhoto} style={{ marginTop: 6, alignSelf: 'flex-start' }}>
                      <Text style={{ color: TEXT_MUTED, fontSize: 12, textDecorationLine: 'underline' }}>사진 변경</Text>
                    </TouchableOpacity>
                  </View>
                ) : (
                  <TouchableOpacity onPress={pickPhoto} disabled={photoUploading}
                    style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: 6,
                      marginTop: 12, paddingVertical: 12, borderRadius: 12, borderWidth: 1, borderStyle: 'dashed', borderColor: BORDER }}>
                    <CameraIcon size={16} color={TEXT_MUTED} />
                    <Text style={{ color: TEXT_MUTED, fontSize: 13 }}>
                      {photoUploading ? '업로드 중...' : '인증샷 추가 (선택)'}
                    </Text>
                  </TouchableOpacity>
                )
              )}

              <View style={{ flexDirection: 'row', gap: 8, marginTop: 14 }}>
                <SecondaryButton label="다시 선택" onPress={() => { setSelected(null); setPhotoUrl(null); }} style={{ flex: 1 }} />
                <GradientButton label="게시하기" onPress={() => onPick(selected, photoUrl)} style={{ flex: 1 }} disabled={photoUploading} />
              </View>
            </>
          ) : (
            <>
              <Text style={s.modalTitle}>탈출 기록 공유하기</Text>
              {records.length === 0 ? (
                <Text style={s.emptyText}>공유할 수 있는 방문 기록이 아직 없어요.</Text>
              ) : (
                <FlatList
                  data={records} keyExtractor={item => item.id}
                  style={{ maxHeight: 340 }}
                  renderItem={({ item }) => (
                    <TouchableOpacity style={s.modalResultRow} onPress={() => setSelected(item)}>
                      <Text style={s.modalResultName}>{item.productName}</Text>
                      {item.bookingFormat === 'show'
                        ? <IconLabel Icon={CheckmarkIcon} size={11} color={COLORS.blue} textStyle={[s.modalResultStore, { color: COLORS.blue }]}>{`관람 완료 · ${item.date}`}</IconLabel>
                        : item.success
                        ? <IconLabel Icon={EscapeRecordSuccessIcon} size={11} color={s.modalResultStore.color} textStyle={s.modalResultStore}>{`탈출 성공 · ${item.date}`}</IconLabel>
                        : <Text style={s.modalResultStore}>{`탈출 실패 · ${item.date}`}</Text>}
                    </TouchableOpacity>
                  )}
                />
              )}
            </>
          )}
        </Pressable>
      </Pressable>
    </Modal>
  );
}

// 77차: 게시글 타입별 아이콘 사각형 색(design 폴더 스펙 — 메시지=블루/테마추천=골드/
// 탈출기록=그린/모집연동=코랄). 기존 COLORS 토큰의 옅은 배경 변형을 재사용.
// 78차 35차: 메시지 전송 시각 표시(댓글처럼) — createdAt은 addCrewPost가 항상
// serverTimestamp()로 넣어두므로 전부 존재. 실시간 구독 직후(서버 확정 전)의 로컬
// pending 상태에선 Firestore가 아직 null을 줄 수 있어 방어.
const formatPostTime = (createdAt) => {
  const d = createdAt?.toDate ? createdAt.toDate() : null;
  if (!d) return '';
  return d.toLocaleTimeString('ko-KR', { hour: 'numeric', minute: '2-digit' });
};

// 78차 72차: 나머지 3종(메시지/탈출기록/모집연동)도 claude.ai/design 크루 목업의 실제
// SVG로 교체 — 이모지 전부 제거. 탈출기록은 기존 CheckmarkIcon과 모양이 같아 재사용.
const POST_TYPE_META = {
  message:         { Icon: CrewMessageIcon, bg: COLORS.blueBg,  color: COLORS.blue },
  // 78차 39차: 전용 아이콘(ThemeRecommendIcon, 별+체크) 적용
  theme_recommend: { Icon: ThemeRecommendIcon, bg: COLORS.goldBg,  color: COLORS.goldLight },
  escape_record:   { Icon: CheckmarkIcon, bg: COLORS.greenBg, color: COLORS.green },
  recruit_link:    { Icon: CrewRecruitLinkIcon, bg: COLORS.boost + '2e', color: COLORS.boost },
  // 78차 66차: 크루장/관리자 전용 공지사항 — 눈에 띄게 골드 테두리 강조
  notice:          { Icon: CrewNoticeIcon, bg: COLORS.goldBg, color: COLORS.goldLight },
};

// ─── 게시판 카드(피드 아이템) ─────────────────────────────────
// 78차 42차: 크루 게시판 신고 — 본인 글은 신고 불가, 중복 신고는 서비스단(reportCrewPost)에서 차단
function useCrewPostReport(item, currentUid, currentNickname) {
  const canReport = !!currentUid && item.uid !== currentUid;
  const submit = async (reason) => {
    try {
      await reportCrewPost({ crewPostId: item.id, reporterUid: currentUid, reporterName: currentNickname || '회원', post: item, reason });
      showAlert('접수 완료', '신고가 접수됐어요. 운영팀이 검토합니다.');
    } catch (e) {
      if (e.message === 'ALREADY_REPORTED') showAlert('안내', '이미 신고한 게시글이에요.');
      else showAlert('오류', '신고 접수 중 오류가 발생했습니다.');
    }
  };
  const handleReport = () => {
    showAlert('게시글 신고', '신고 사유를 선택해주세요.', [
      { text: '취소', style: 'cancel' },
      { text: '욕설/비방', onPress: () => submit('욕설/비방') },
      { text: '광고/스팸', onPress: () => submit('광고/스팸') },
      { text: '부적절한 내용', onPress: () => submit('부적절한 내용') },
      { text: '기타', onPress: () => submit('기타') },
    ]);
  };
  return { canReport, handleReport };
}

function ReportFlag({ onPress }) {
  return (
    <TouchableOpacity onPress={onPress} hitSlop={{ top: 6, bottom: 6, left: 6, right: 6 }}>
      {/* 80차 계속: 이모지 🚩 → 이미 RecruitDetailScreen.js/ReviewCard.js의 신고 버튼이
          쓰고 있는 기존 아이콘으로 통일(신규 자산 불필요) */}
      <IconLabel Icon={ReportFlagIcon} size={11} color={TEXT_MUTED} textStyle={{ color: TEXT_MUTED, fontSize: 11 }}>신고</IconLabel>
    </TouchableOpacity>
  );
}

// 78차 42차: 크루 게시판 사용자 차단 — 차단하면 같은 크루 안에서 그 사람 글만 내 화면에서 숨겨짐
function useCrewPostBlock(item, currentUid) {
  const { refreshProfile } = useAuth();
  const canBlock = !!currentUid && item.uid !== currentUid;
  const handleBlock = () => {
    showAlert('사용자 차단', `"${item.nickname || '이 사용자'}"의 글을 앞으로 보지 않아요.`, [
      { text: '취소', style: 'cancel' },
      { text: '차단', style: 'destructive', onPress: async () => {
        try {
          await blockUser(currentUid, item.uid);
          await refreshProfile();
        } catch { showAlert('오류', '차단 처리 중 오류가 발생했습니다.'); }
      }},
    ]);
  };
  return { canBlock, handleBlock };
}

function BlockFlag({ onPress }) {
  return (
    <TouchableOpacity onPress={onPress} hitSlop={{ top: 6, bottom: 6, left: 6, right: 6 }}>
      <IconLabel Icon={NoEntryIcon} size={11} color={TEXT_MUTED} textStyle={{ color: TEXT_MUTED, fontSize: 11 }}>차단</IconLabel>
    </TouchableOpacity>
  );
}

function PostItem({ item, navigation, currentUid, currentNickname }) {
  const meta = POST_TYPE_META[item.type] || POST_TYPE_META.message;
  const { canReport, handleReport } = useCrewPostReport(item, currentUid, currentNickname);
  const { canBlock, handleBlock } = useCrewPostBlock(item, currentUid);

  if (item.type === 'recruit_link') {
    // 78차: 모집글 제목(item.text)만 보이던 것 → 어떤 테마를 언제/어디서 몇 명 모집하는지
    // 한눈에 보이게 테마추천 카드와 동일한 톤의 미니 정보 카드 추가(RecruitWriteScreen.js가
    // 작성 시점에 넘긴 productName/region/scheduledDate·Time/totalSlots 스냅샷 사용).
    const dateLabel = item.scheduledDate
      ? new Date(item.scheduledDate).toLocaleDateString('ko-KR', { month:'long', day:'numeric' })
      : null;
    return (
      <TouchableOpacity style={s.postCard}
        onPress={() => navigation.navigate('RecruitDetail', { recruitId: item.recruitId })}>
        <View style={s.postRow}>
          <View style={[s.postIconSquare, { backgroundColor: meta.bg }]}>{meta.Icon ? <meta.Icon size={18} color={meta.color} /> : <Text style={s.postIconText}>{meta.icon}</Text>}</View>
          <View style={{ flex: 1, gap: 4 }}>
            <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
              <Text style={[s.postTypeLabel, { color: meta.color }]}>모집 연동</Text>
              <View style={{ flexDirection: 'row', gap: 10 }}>
                {canReport && <ReportFlag onPress={handleReport} />}
                {canBlock && <BlockFlag onPress={handleBlock} />}
              </View>
            </View>
            <Text style={s.postText}>{item.nickname} · {item.text}</Text>
            {!!item.productName && (
              <View style={s.themeCardRow}>
                {item.imageUrl
                  ? <Image source={{ uri: item.imageUrl }} style={s.themeCardThumb} />
                  : <View style={[s.themeCardThumb, s.themeCardThumbPlaceholder]}><CrewEmblemIcon size={22} color="#5a5a68" /></View>}
                <View style={{ flex: 1, gap: 3 }}>
                  <Text style={s.themeCardName} numberOfLines={1}>{item.productName}</Text>
                  <Text style={s.themeCardStore} numberOfLines={1}>
                    {[item.region, dateLabel, item.scheduledTime].filter(Boolean).join(' · ')}
                  </Text>
                  {item.totalSlots ? <IconLabel Icon={PeopleIcon} size={10} color={TEXT_MUTED} textStyle={s.themeCardStore}>정원 {item.totalSlots}명</IconLabel> : null}
                  {/* 80차 후속: [정책 확정] 배지 순서 — ①형식(필수) → ②19금(장르 배지는
                      이 카드에 원래 없어 해당 없음, 다른 fork 재검증으로 발견된 사각지대) */}
                  <View style={{ flexDirection: 'row', gap: 6, marginTop: 2 }}>
                    {item.bookingFormat === 'show' ? (
                      <View style={[s.themeCardGenreChip, { backgroundColor: COLORS.blue + '26', borderColor: COLORS.blue + '59' }]}>
                        <Text style={[s.themeCardGenreText, { color: COLORS.blue }]}>체험형</Text>
                      </View>
                    ) : (
                      <View style={[s.themeCardGenreChip, { backgroundColor: COLORS.teal + '26', borderColor: COLORS.teal + '59' }]}>
                        <Text style={[s.themeCardGenreText, { color: COLORS.teal }]}>방탈출</Text>
                      </View>
                    )}
                    {item.isAdultOnly && (
                      <View style={[s.themeCardGenreChip, { backgroundColor: COLORS.dangerBg, borderColor: COLORS.danger + '59' }]}>
                        <Text style={[s.themeCardGenreText, { color: COLORS.danger }]}>19금</Text>
                      </View>
                    )}
                  </View>
                </View>
              </View>
            )}
          </View>
          <View style={[s.postJoinPill]}><Text style={s.postJoinPillText}>참여</Text></View>
        </View>
      </TouchableOpacity>
    );
  }
  if (item.type === 'theme_recommend') {
    const gm = item.genre ? getGenreMeta(item.genre) : null;
    return (
      <TouchableOpacity style={s.postCard}
        onPress={() => item.productId && navigation.navigate('ThemeDetail', { product: { id: item.productId } })}>
        <View style={s.postRow}>
          <View style={[s.postIconSquare, { backgroundColor: meta.bg }]}>{meta.Icon ? <meta.Icon size={18} color={meta.color} /> : <Text style={s.postIconText}>{meta.icon}</Text>}</View>
          <View style={{ flex: 1, gap: 4 }}>
            <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
              <Text style={[s.postTypeLabel, { color: meta.color }]}>테마 추천</Text>
              <View style={{ flexDirection: 'row', gap: 10 }}>
                {canReport && <ReportFlag onPress={handleReport} />}
                {canBlock && <BlockFlag onPress={handleBlock} />}
              </View>
            </View>
            <Text style={s.postMeta}>{item.nickname}</Text>
            <View style={s.themeCardRow}>
              {item.imageUrl
                ? <Image source={{ uri: item.imageUrl }} style={s.themeCardThumb} />
                : <View style={[s.themeCardThumb, s.themeCardThumbPlaceholder]}><CrewEmblemIcon size={22} color="#5a5a68" /></View>}
              <View style={{ flex: 1, gap: 3 }}>
                <Text style={s.themeCardName} numberOfLines={1}>{item.text}</Text>
                {!!item.storeName && <Text style={s.themeCardStore} numberOfLines={1}>{item.storeName}</Text>}
                <View style={{ flexDirection: 'row', alignItems: 'center', gap: 6 }}>
                  {/* 80차 후속: [정책 확정] 배지 순서 — ①형식(방탈출/체험형, 필수) → ②19금 → ③장르 */}
                  {item.bookingFormat === 'show' ? (
                    <View style={[s.themeCardGenreChip, { backgroundColor: COLORS.blue + '26', borderColor: COLORS.blue + '59' }]}>
                      <Text style={[s.themeCardGenreText, { color: COLORS.blue }]}>체험형</Text>
                    </View>
                  ) : (
                    <View style={[s.themeCardGenreChip, { backgroundColor: COLORS.teal + '26', borderColor: COLORS.teal + '59' }]}>
                      <Text style={[s.themeCardGenreText, { color: COLORS.teal }]}>방탈출</Text>
                    </View>
                  )}
                  {/* 80차 후속: 체험형 전용 — 단독 대관/합석 뱃지 */}
                  {item.bookingFormat === 'show' && (
                    <View style={[s.themeCardGenreChip, { backgroundColor: COLORS.purple + '26', borderColor: COLORS.purple + '59' }]}>
                      <Text style={[s.themeCardGenreText, { color: COLORS.purple }]}>{getSeatingTypeLabel(item.seatingType)}</Text>
                    </View>
                  )}
                  {item.isAdultOnly && (
                    <View style={[s.themeCardGenreChip, { backgroundColor: COLORS.dangerBg, borderColor: COLORS.danger + '59' }]}>
                      <Text style={[s.themeCardGenreText, { color: COLORS.danger }]}>19금</Text>
                    </View>
                  )}
                  {gm && (
                    <View style={[s.themeCardGenreChip, { backgroundColor: gm.color + '26', borderColor: gm.color + '59' }]}>
                      <Text style={[s.themeCardGenreText, { color: gm.color }]}>{item.genre}</Text>
                    </View>
                  )}
                  {/* 80차 후속: 체험형은 1인당 단가로 표기 */}
                  {item.bookingFormat === 'show'
                    ? (item.pricePerPerson > 0 && <Text style={s.themeCardPrice}>{Number(item.pricePerPerson).toLocaleString()}원 (1인당)</Text>)
                    : (item.minPrice != null && <Text style={s.themeCardPrice}>{Number(item.minPrice).toLocaleString()}원~</Text>)}
                </View>
              </View>
            </View>
          </View>
        </View>
      </TouchableOpacity>
    );
  }
  if (item.type === 'notice') {
    // 78차 66차: 크루장/관리자 공지사항 — 골드 테두리로 눈에 띄게 강조
    return (
      <View style={[s.postCard, s.noticeCard]}>
        <View style={s.postRow}>
          <View style={[s.postIconSquare, { backgroundColor: meta.bg }]}><meta.Icon size={18} color={meta.color} /></View>
          <View style={{ flex: 1 }}>
            <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
              <Text style={[s.postTypeLabel, { color: meta.color }]}>공지</Text>
              {canReport && <ReportFlag onPress={handleReport} />}
            </View>
            {!!item.title && <Text style={s.noticeTitle}>{item.title}</Text>}
            <Text style={s.postText}>{item.text}</Text>
          </View>
        </View>
      </View>
    );
  }
  if (item.type === 'escape_record') {
    // 80차 후속: 체험형은 성공/실패가 없어 "탈출 기록"이 아니라 "재밌으니 보라"는 추천
    // 카드로 — theme_recommend와 동일한 썸네일 레이아웃 재사용, 아래에 개인 추천 문구.
    if (item.bookingFormat === 'show') {
      const gm = item.genre ? getGenreMeta(item.genre) : null;
      return (
        <TouchableOpacity style={s.postCard}
          onPress={() => item.productId && navigation.navigate('ThemeDetail', { product: { id: item.productId } })}>
          <View style={s.postRow}>
            <View style={[s.postIconSquare, { backgroundColor: meta.bg }]}>{meta.Icon ? <meta.Icon size={18} color={meta.color} /> : <Text style={s.postIconText}>{meta.icon}</Text>}</View>
            <View style={{ flex: 1, gap: 4 }}>
              <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                <Text style={[s.postTypeLabel, { color: meta.color }]}>관람 추천</Text>
                <View style={{ flexDirection: 'row', gap: 10 }}>
                  {canReport && <ReportFlag onPress={handleReport} />}
                  {canBlock && <BlockFlag onPress={handleBlock} />}
                </View>
              </View>
              <Text style={s.postMeta}>{item.nickname}</Text>
              <View style={s.themeCardRow}>
                {item.imageUrl
                  ? <Image source={{ uri: item.imageUrl }} style={s.themeCardThumb} />
                  : <View style={[s.themeCardThumb, s.themeCardThumbPlaceholder]}><CrewEmblemIcon size={22} color="#5a5a68" /></View>}
                <View style={{ flex: 1, gap: 3 }}>
                  <Text style={s.themeCardName} numberOfLines={1}>{item.text}</Text>
                  {!!item.storeName && <Text style={s.themeCardStore} numberOfLines={1}>{item.storeName}</Text>}
                  <View style={{ flexDirection: 'row', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                    {/* 80차 후속: [정책 확정] 배지 순서 — ①형식(필수) → ②19금 → ③장르(이 카드는 항상 체험형) */}
                    <View style={[s.themeCardGenreChip, { backgroundColor: COLORS.blue + '26', borderColor: COLORS.blue + '59' }]}>
                      <Text style={[s.themeCardGenreText, { color: COLORS.blue }]}>체험형</Text>
                    </View>
                    <View style={[s.themeCardGenreChip, { backgroundColor: COLORS.purple + '26', borderColor: COLORS.purple + '59' }]}>
                      <Text style={[s.themeCardGenreText, { color: COLORS.purple }]}>{getSeatingTypeLabel(item.seatingType)}</Text>
                    </View>
                    {item.isAdultOnly && (
                      <View style={[s.themeCardGenreChip, { backgroundColor: COLORS.dangerBg, borderColor: COLORS.danger + '59' }]}>
                        <Text style={[s.themeCardGenreText, { color: COLORS.danger }]}>19금</Text>
                      </View>
                    )}
                    {gm && (
                      <View style={[s.themeCardGenreChip, { backgroundColor: gm.color + '26', borderColor: gm.color + '59' }]}>
                        <Text style={[s.themeCardGenreText, { color: gm.color }]}>{item.genre}</Text>
                      </View>
                    )}
                  </View>
                </View>
              </View>
              {!!item.comment && <Text style={[s.postText, { marginTop: 2 }]}>{item.comment}</Text>}
            </View>
          </View>
        </TouchableOpacity>
      );
    }
    return (
      <View style={s.postCard}>
        <View style={s.postRow}>
          <View style={[s.postIconSquare, { backgroundColor: meta.bg }]}>{meta.Icon ? <meta.Icon size={18} color={meta.color} /> : <Text style={s.postIconText}>{meta.icon}</Text>}</View>
          <View style={{ flex: 1 }}>
            <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
              <Text style={[s.postTypeLabel, { color: meta.color }]}>탈출 기록</Text>
              <View style={{ flexDirection: 'row', gap: 10 }}>
                {canReport && <ReportFlag onPress={handleReport} />}
                {canBlock && <BlockFlag onPress={handleBlock} />}
              </View>
            </View>
            <Text style={s.postText}>{item.nickname} · {item.text}</Text>
            {/* 78차 69차: 힌트 횟수/소요 시간 — "허전하다"는 신고로 매장이 입력해둔
                자랑거리 데이터를 실제로 노출 */}
            {(item.escapeTime || item.hintCount != null) && (
              <View style={{ flexDirection: 'row', gap: 14, marginTop: 6 }}>
                {item.escapeTime && <IconLabel Icon={ClockIcon} size={11} color={TEXT_MUTED} textStyle={s.postMeta}>{item.escapeTime}</IconLabel>}
                {item.hintCount != null && <IconLabel Icon={HintUsageIcon} size={11} color={s.postMeta.color} textStyle={s.postMeta}>힌트 {item.hintCount}회</IconLabel>}
              </View>
            )}
            {/* 80차 계속: 탈출 인증샷 — 참가자가 직접 첨부한 사진(선택), 없으면 렌더 안 함 */}
            {!!item.imageUrl && (
              <Image source={{ uri: item.imageUrl }} style={{ width: '100%', height: 180, borderRadius: 12, marginTop: 8 }} />
            )}
          </View>
        </View>
      </View>
    );
  }
  return (
    <View style={s.postCard}>
      <View style={s.postRow}>
        {/* 80차 계속: 메시지 카드는 발신자 대표 이미지가 있으면 그걸(원형 아바타), 없으면
            기존 타입 아이콘 정사각형을 그대로 보여줌 — "누가 보냈는지"를 아이콘보다 사진으로 */}
        {item.photoURL ? (
          <Image source={{ uri: item.photoURL }} style={[s.postIconSquare, { borderRadius: 16 }]} />
        ) : (
          <View style={[s.postIconSquare, { backgroundColor: meta.bg }]}>{meta.Icon ? <meta.Icon size={18} color={meta.color} /> : <Text style={s.postIconText}>{meta.icon}</Text>}</View>
        )}
        <View style={{ flex: 1 }}>
          <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
            <Text style={[s.postTypeLabel, { color: meta.color }]}>메시지</Text>
            <View style={{ flexDirection: 'row', alignItems: 'center', gap: 8 }}>
              <Text style={s.postTime}>{formatPostTime(item.createdAt)}</Text>
              <View style={{ flexDirection: 'row', gap: 10 }}>
                {canReport && <ReportFlag onPress={handleReport} />}
                {canBlock && <BlockFlag onPress={handleBlock} />}
              </View>
            </View>
          </View>
          <Text style={s.postMeta}>{item.nickname}</Text>
          <Text style={s.postText}>{item.text}</Text>
        </View>
      </View>
    </View>
  );
}

// ─── 크루 랭킹 모달 ─────────────────────────────────────────────
// 80차 계속: BrowseCrews(크루 없을 때)에만 랭킹을 넣었더니, 정작 랭킹에 신경 쓸
// 크루원 본인은 크루가 있으면 그 화면에 도달할 방법이 없었음(CrewHome으로 바로
// 라우팅됨) — 이미 크루가 있는 사람도 볼 수 있게 CrewHome에서 여는 모달로 보완.
function CrewRankingModal({ visible, onClose, myCrewId }) {
  const [topCrews, setTopCrews] = useState([]);
  useEffect(() => {
    if (!visible) return;
    listTopCrews(10).then(setTopCrews).catch(() => setTopCrews([]));
  }, [visible]);
  return (
    <Modal visible={visible} animationType="slide" transparent onRequestClose={onClose}>
      <Pressable style={s.modalBackdrop} onPress={onClose}>
        <Pressable style={s.modalSheet} onPress={() => {}}>
          <IconLabel Icon={TrophyIcon} size={s.modalTitle.fontSize || 16} color={s.modalTitle.color} textStyle={s.modalTitle}>크루 랭킹</IconLabel>
          {topCrews.length === 0 ? (
            <Text style={s.emptyText}>랭킹 정보를 불러오는 중이에요.</Text>
          ) : topCrews.map((crew, idx) => (
            <View key={crew.id} style={{ flexDirection: 'row', alignItems: 'center', gap: 10, paddingVertical: 8 }}>
              <RankBadge index={idx} />
              <Text style={{ flex: 1, fontSize: 13, color: crew.id === myCrewId ? GOLD : TEXT, fontWeight: crew.id === myCrewId ? '900' : '600' }} numberOfLines={1}>
                {crew.name}{crew.id === myCrewId ? ' (우리 크루)' : ''}
              </Text>
              <Text style={{ fontSize: 12, color: TEXT_MUTED }}>Lv.{crew.level} · {(crew.memberUids || []).length}명</Text>
            </View>
          ))}
        </Pressable>
      </Pressable>
    </Modal>
  );
}

// ─── 크루 있을 때: 정보 + 게시판 ──────────────────────────────
function CrewHome({ navigation, crew, uid, nickname, onLeftOrChanged, blockedUsers = [], isMinor = false, photoURL = null }) {
  const [posts, setPosts] = useState([]);
  // 78차 42차: 차단한 유저의 글은 피드에서만 숨김(크루 통계는 원본 posts 그대로 집계)
  // 80차 계속: [버그 수정, fork로 발견] 크루는 성인전용 공간이 아닌데, 19금 테마추천/
  // 관람추천/모집연동 카드가 isAdultOnly 필터 없이 그대로 렌더돼(테마명/사진/매장명까지)
  // 확인된 미성년 크루원에게 실제 콘텐츠가 노출되고 있었음 — isMinor prop이 테마 선택
  // 모달에만 쓰이고 정작 피드 자체엔 안 걸려있던 사각지대.
  const visiblePosts = useMemo(
    () => posts.filter(p => !blockedUsers.includes(p.uid) && !(isMinor && p.isAdultOnly)),
    [posts, blockedUsers, isMinor]
  );
  const [message, setMessage] = useState('');
  const [showThemeModal, setShowThemeModal] = useState(false);
  const [showEscapeModal, setShowEscapeModal] = useState(false);
  // 78차 69차: 크루 정보 카드(이름+통계)가 대화창 공간을 너무 많이 차지한다는 신고 —
  // 통계 행은 기본 접어두고 탭하면 펼치도록 변경(이름/인원/관리 버튼은 항상 보임).
  const [statsExpanded, setStatsExpanded] = useState(false);
  const [myRank, setMyRank] = useState(null);
  const [showRankingModal, setShowRankingModal] = useState(false);
  const isLeader  = crew.ownerUid === uid;
  const isManager = crew.managerUid === uid;
  // 80차 계속: @멘션/@전체 — 자동완성용 멤버 명단(닉네임). getCrewMemberProfilesCF가
  // 이제 일반 멤버도 members(승인 명단)는 조회 가능하도록 확장됨.
  const [crewMembers, setCrewMembers] = useState([]);
  const [mentionQuery, setMentionQuery] = useState(null); // null=비활성, string=@뒤 입력중인 접두어

  useEffect(() => {
    const unsub = listenCrewPosts(crew.id, setPosts);
    return unsub;
  }, [crew.id]);

  useEffect(() => {
    let active = true;
    getCrewMemberProfilesCF(crew.id).then(({ members }) => {
      if (active) setCrewMembers(members || []);
    }).catch(() => {});
    return () => { active = false; };
  }, [crew.id]);

  // 80차 계속: 통계를 펼칠 때만 조회(항상 켜져있는 크루 대화창에서 불필요한 쿼리 방지)
  useEffect(() => {
    if (!statsExpanded) return;
    let active = true;
    listTopCrews(100).then(list => {
      if (!active) return;
      const idx = list.findIndex(c => c.id === crew.id);
      setMyRank(idx >= 0 ? idx + 1 : null);
    }).catch(() => {});
    return () => { active = false; };
  }, [statsExpanded, crew.id]);

  const sendMessage = async () => {
    const text = message.trim();
    if (!text) return;
    setMessage('');
    setMentionQuery(null);
    // 80차 계속: 서버(onCrewPostCreated)가 crews.memberUids로 다시 검증하므로 여기서
    // 계산한 mentions/mentionAll은 어디까지나 힌트 — 위조해도 서버가 걸러냄.
    const { mentions, mentionAll } = parseMentions(text, crewMembers);
    try { await addCrewMessage({ crewId: crew.id, uid, nickname, text, photoURL, mentions, mentionAll }); }
    catch { showAlert('오류', '메시지 전송에 실패했어요.'); }
  };

  // 80차 계속: @ 입력 감지 — 마지막 "@" 뒤에 공백 없이 이어지는 부분을 자동완성
  // 검색어로 취급(커서 위치 추적 없이 "텍스트 끝에서 입력 중"이라는 단순한 전제로
  // 채팅 입력창에는 충분함). 공백이 들어가거나 "@" 자체가 없으면 자동완성 닫힘.
  const handleMessageChange = (v) => {
    setMessage(v);
    const at = v.lastIndexOf('@');
    if (at === -1) { setMentionQuery(null); return; }
    const after = v.slice(at + 1);
    setMentionQuery(/\s/.test(after) ? null : after);
  };

  const mentionSuggestions = useMemo(() => {
    if (mentionQuery === null) return [];
    const q = mentionQuery.toLowerCase();
    const all = [{ uid: '__all__', nickname: '전체' }, ...crewMembers.filter(m => m.uid !== uid)];
    return all.filter(m => (m.nickname || '').toLowerCase().includes(q)).slice(0, 5);
  }, [mentionQuery, crewMembers, uid]);

  const insertMention = (targetNickname) => {
    const at = message.lastIndexOf('@');
    if (at === -1) return;
    setMessage(message.slice(0, at) + `@${targetNickname} `);
    setMentionQuery(null);
  };

  const pickTheme = async (product) => {
    setShowThemeModal(false);
    const p = normalizeProduct(product);
    const minPrice = p.pricing?.length > 0 ? Math.min(...p.pricing.map(pr => Number(pr.price) || 0)) : (Number(p.price) || null);
    try {
      await addCrewThemeRecommend({
        crewId: crew.id, uid, nickname, productId: p.id, text: p.name,
        imageUrl: p.imageUrl || null, storeName: fullStoreName(p.storeName, p.branchName), genre: p.genre || '', difficulty: p.difficulty || '', minPrice,
        // 80차 후속: 체험형(정원제) 배지/1인당 가격/좌석형태 표시용
        bookingFormat: p.bookingFormat || 'room', pricePerPerson: Number(p.pricePerPerson) || 0, seatingType: p.seatingType || 'shared',
        isAdultOnly: !!p.isAdultOnly,
      });
    } catch { showAlert('오류', '테마 추천에 실패했어요.'); }
  };

  // 78차 66차: EscapeShareModal이 이제 매장이 결과입력한 예약(reservations.success)을
  // 직접 넘겨주므로, 여기서 별도로 예약 문서를 재조회할 필요 없음(78차 32차엔 리뷰
  // 경유로만 이 값을 가져올 수 있어 조회가 필요했었음).
  // 78차 69차: escapeTime/hintCount(매장이 이미 입력해둔 소요시간·힌트 횟수)도 같이 저장 —
  // "공유해도 자랑거리가 하나도 안 보인다"는 신고 반영.
  const pickEscape = async (reservation, photoUrl = null) => {
    setShowEscapeModal(false);
    try {
      // 80차 후속: 체험형은 theme_recommend와 동일한 톤(썸네일+장르+가격)의 "관람 추천"
      // 카드로 — 성공/실패 개념이 없어 기존 탈출기록 카드 형태를 그대로 쓰면 안 맞음.
      if (reservation.bookingFormat === 'show') {
        const product = await getProductById(reservation.productId).catch(() => null);
        await addCrewEscapeShare({
          crewId: crew.id, uid, nickname,
          bookingFormat: 'show',
          productId: reservation.productId,
          text: reservation.productName,
          comment: buildShowShareText(reservation),
          imageUrl: product?.imageUrl || null,
          genre: product?.genre || '',
          storeName: reservation.storeName || '',
          pricePerPerson: Number(product?.pricePerPerson) || 0,
          seatingType: product?.seatingType || 'shared',
          isAdultOnly: !!product?.isAdultOnly,
        });
        return;
      }
      // 80차 계속(재검토로 발견): show 분기와 달리 isAdultOnly를 안 찍고 있어서, 19금
      // 테마의 인증샷이 확인된 미성년 크루원에게 visiblePosts 필터를 그대로 우회해 노출될
      // 수 있었음 — reservations 문서엔 이 필드가 없어 테마를 직접 조회해서 채움.
      const product = await getProductById(reservation.productId).catch(() => null);
      await addCrewEscapeShare({
        crewId: crew.id, uid, nickname,
        imageUrl: photoUrl || null, // 80차 계속: 참가자가 직접 찍은 탈출 인증샷(선택)
        text: buildEscapeShareText(reservation),
        escapeResult: reservation.success,
        escapeTime: reservation.escapeTime || null,
        hintCount: reservation.hintCount != null ? reservation.hintCount : null,
        isAdultOnly: !!product?.isAdultOnly,
      });
    } catch { showAlert('오류', '탈출 기록 공유에 실패했어요.'); }
  };

  // 78차 32차: "함께 탈출/성공률/크루 레벨" 3-스탯 — crewPosts(이미 실시간 구독 중인 posts)
  // 에서 직접 집계, 추가 쿼리 없음.
  // 80차 후속: escape_record 타입에 체험형 "관람 추천" 공유도 섞이게 되면서(성공/실패
  // 개념이 없는 관람 기록) "함께 탈출"이라는 라벨이 더 이상 정확하지 않아 "함께한 활동"으로
  // 넓힘 — 개수는 두 형식을 합쳐서 그대로 집계(성공률은 escapeResult가 있는 것만 걸러서
  // 계산하므로 체험형이 섞여도 왜곡되지 않음, 변경 없음).
  const crewStats = useMemo(() => {
    const escapeRecords = posts.filter(p => p.type === 'escape_record');
    const rated = escapeRecords.filter(p => p.escapeResult === true || p.escapeResult === false);
    const successCount = rated.filter(p => p.escapeResult === true).length;
    // 80차 후속: recruitLinkCount는 실시간 posts(limit 100)를 직접 세지 않고 서버 카운터
    // (crews.recruitLinkCount, 랭킹 계산과 동일 소스)를 써야 함 — 게시글이 100개를 넘는
    // 활발한 크루는 두 값이 어긋나 같은 화면에서 Lv.가 다르게 보일 수 있었음(fork로 발견).
    const daysActive = crew?.createdAt
      ? Math.max(0, Math.floor((Date.now() - new Date(crew.createdAt).getTime()) / 86400000))
      : 0;
    return {
      escapeCount: escapeRecords.length,
      successRate: rated.length > 0 ? Math.round((successCount / rated.length) * 100) : null,
      level: getCrewLevel({ recruitLinkCount: crew?.recruitLinkCount || 0, daysActive }).level,
    };
  }, [posts, crew?.createdAt, crew?.recruitLinkCount]);

  return (
    <KeyboardAvoidingView style={{ flex: 1 }} behavior={Platform.OS === 'ios' ? 'padding' : undefined}>
      {/* 78차 66차: 자물쇠 고정 아이콘 → 크루장/관리자가 지정한 대표사진(crew.imageUrl,
          CrewManageScreen.js에서 업로드) 노출, 없으면 기존 자물쇠 유지.
          78차 66차: 별도 카드였던 3-스탯 행을 이 안으로 합쳐 세로 공간 절약(메시지
          피드 영역 확보) — crewStats 집계 로직 자체는 변경 없음. */}
      <View style={s.crewInfoBar}>
        {/* 80차 계속: [레이아웃 재구성] 아바타+이름+통계정보+버튼 3개가 한 줄에 몰려있어서
            버튼 폭에 밀린 "통계 보기" 텍스트가 한 글자씩 세로로 쌓이는 버그가 있었음 —
            "정체성(아바타/이름/관리버튼)" 행과 "통계 토글(Lv/정원/진행바)" 행을 분리해
            두 번째 행이 항상 카드 전체 폭을 온전히 쓰도록 함. */}
        {/* 오늘 순차 기기테스트(360dp)로 발견/수정: 위 분리로도 "정체성" 행 자체가 여전히
            아바타+이름+버튼3개를 한 줄에 욱여넣고 있어서, 좁은 화면에서 버튼 3개(고정폭,
            flexShrink 기본값 0이라 절대 안 줄어듦)가 name의 flex:1 컨테이너를 사실상
            0px까지 밀어붙여 크루명이 한 글자씩 세로로 쌓이는 동일 버그가 재발했음 —
            버튼 그룹을 이름과 같은 줄에서 완전히 빼서 별도 줄로 분리(이 파일이 통계
            토글 때 이미 검증한 "제약 요소는 자기만의 온전한 줄을 갖게 한다" 원칙 재적용). */}
        <View style={{ flexDirection: 'row', alignItems: 'center', gap: 10 }}>
          <View style={s.crewEmblem}>
            {crew.imageUrl
              ? <Image source={{ uri: crew.imageUrl }} style={s.crewEmblemImg} />
              : <CrewEmblemIcon size={18} />}
          </View>
          <View style={{ flex: 1 }}>
            <View style={{ flexDirection: 'row', alignItems: 'center', gap: 4, flexWrap: 'wrap' }}>
              <Text style={s.crewInfoName} numberOfLines={1}>{crew.name}</Text>
              {isLeader && <CrownIcon size={s.roleTag.fontSize || 11} color={s.roleTag.color} />}
              {isManager && <IconLabel Icon={AdminIcon} size={s.roleTag.fontSize || 11} color={s.roleTag.color} textStyle={s.roleTag}>관리자</IconLabel>}
            </View>
          </View>
        </View>
        {/* 80차 계속: [크기 축소] 대화창(메시지 피드)이 안 보인다는 신고로 소개 카드
            전체를 절반 가까이 압축 — 이 행의 marginTop은 삭제하고 부모 crewInfoBar의
            gap(12→6)만으로 행간을 처리(기존엔 gap+marginTop이 중복으로 더해지고 있었음,
            시각적 밸런스 변화 없이 높이만 절약). 버튼/아이콘/폰트 크기도 전부 축소.
            80차 계속: [접근성 수정, fork 재검토로 발견] 축소 후 실제 렌더 높이가
            22px 수준까지 줄어 접근성 최소 터치영역(iOS 44pt/Android 48dp) 미달이었음 —
            시각적 크기는 그대로 두고 hitSlop으로 실제 터치 판정 영역만 넓힘. */}
        <View style={{ flexDirection: 'row', gap: 5 }}>
          {/* 78차 70차: 공지사항 전용 화면 진입점 — 채팅형 피드에 섞여 새 멤버가 지난
              공지를 놓치기 쉬워서, 누구나 항상 들어가서 볼 수 있는 고정 버튼으로 노출.
              80차 계속: 이모지(📌/🏆) → 이미 있는 아이콘(CrewNoticeIcon/TrophyIcon)으로 —
              SecondaryButton이 아이콘+라벨 조합을 지원하지 않아 전용 Pressable로 구성 */}
          <Pressable
            onPress={() => navigation.navigate('CrewNotices', { crewId: crew.id, canManage: isLeader || isManager })}
            hitSlop={{ top: 10, bottom: 10, left: 6, right: 6 }}
            style={({ pressed }) => [s.manageIconBtn, pressed && s.manageIconBtnPressed]}>
            <IconLabel Icon={CrewNoticeIcon} size={11} color={GOLD} textStyle={s.manageBtnText}>공지</IconLabel>
          </Pressable>
          <Pressable
            onPress={() => setShowRankingModal(true)}
            hitSlop={{ top: 10, bottom: 10, left: 6, right: 6 }}
            style={({ pressed }) => [s.manageIconBtn, pressed && s.manageIconBtnPressed]}>
            <IconLabel Icon={TrophyIcon} size={11} color={GOLD} textStyle={s.manageBtnText}>랭킹</IconLabel>
          </Pressable>
          {(isLeader || isManager) && (
            <SecondaryButton label="관리" onPress={() => navigation.navigate('CrewManage', { crewId: crew.id })} style={s.manageBtn} textStyle={s.manageBtnText} hitSlop={{ top: 10, bottom: 10, left: 6, right: 6 }} />
          )}
        </View>

        {/* 80차 계속: "N/40명 · Lv.X" 통계 토글 — 이제 카드 전체 폭을 온전히 씀 */}
        <Pressable onPress={() => setStatsExpanded(v => !v)}>
          <View style={{ flexDirection: 'row', alignItems: 'center', gap: 8 }}>
            <View style={s.crewLevelPill}>
              <Text style={s.crewLevelPillText}>Lv.{crewStats.level}</Text>
            </View>
            <Text style={s.crewInfoMembers}>{(crew.memberUids || []).length}/{getCrewCap(crew)}명</Text>
            <Text style={s.crewInfoToggle}>{statsExpanded ? '▲' : '▼ 통계 보기'}</Text>
          </View>
          <View style={s.crewCapTrack}>
            <View style={[s.crewCapFill, { width: `${Math.min(100, Math.round(((crew.memberUids || []).length / getCrewCap(crew)) * 100))}%` }]} />
          </View>
        </Pressable>

        {/* 78차 69차: 통계 행을 기본 접어둠 — 크루 이름 줄에 레벨을 이미 요약해서 보여주므로
            펼치지 않아도 최소한의 정보는 확인 가능 */}
        {statsExpanded && (
          <View style={s.crewStatsRow}>
            <View style={s.crewStatItem}>
              <Text style={s.crewStatValue}>{crewStats.escapeCount}회</Text>
              <Text style={s.crewStatLabel}>함께한 활동</Text>
            </View>
            <View style={s.crewStatDivider} />
            <View style={s.crewStatItem}>
              <Text style={s.crewStatValue}>{crewStats.successRate != null ? `${crewStats.successRate}%` : '-'}</Text>
              <Text style={s.crewStatLabel}>성공률</Text>
            </View>
            <View style={s.crewStatDivider} />
            <View style={s.crewStatItem}>
              <Text style={s.crewStatValue}>Lv.{crewStats.level}</Text>
              <Text style={s.crewStatLabel}>크루 레벨</Text>
            </View>
            <View style={s.crewStatDivider} />
            <View style={s.crewStatItem}>
              <Text style={s.crewStatValue}>{myRank != null ? `${myRank}위` : '-'}</Text>
              <Text style={s.crewStatLabel}>전체 순위</Text>
            </View>
          </View>
        )}
      </View>

      <FlatList
        data={visiblePosts}
        keyExtractor={item => item.id}
        contentContainerStyle={{ padding: 16, paddingBottom: 8 }}
        renderItem={({ item }) => <PostItem item={item} navigation={navigation} currentUid={uid} currentNickname={nickname} />}
        ListEmptyComponent={<Text style={[s.emptyText, { marginTop: 40 }]}>아직 게시글이 없어요. 첫 메시지를 남겨보세요!</Text>}
      />

      {/* 78차: design 스펙 — 테마추천(골드 틴트+별), 탈출기록공유(그린 틴트+체크)로
          시각 구분. 공용 SecondaryButton은 아이콘+라벨 조합을 지원하지 않아 이 화면
          전용 Pressable로 직접 구성. */}
      <View style={s.quickActionsRow}>
        <Pressable
          onPress={() => setShowThemeModal(true)}
          style={({ pressed }) => [s.quickActionBtn, s.quickActionGold, pressed && s.quickActionGoldPressed]}>
          <ThemeRecommendIcon size={13} color={GOLD} />
          <Text style={[s.quickActionText, { color: COLORS.goldLight }]}>테마 추천</Text>
        </Pressable>
        <Pressable
          onPress={() => setShowEscapeModal(true)}
          style={({ pressed }) => [s.quickActionBtn, s.quickActionGreen, pressed && s.quickActionGreenPressed]}>
          <CheckmarkIcon size={13} color={COLORS.success} />
          <Text style={[s.quickActionText, { color: COLORS.success }]}>탈출기록 공유</Text>
        </Pressable>
      </View>

      {/* 80차 계속: @멘션 자동완성 — "@" 뒤에 공백 없이 이어지는 입력에 맞춰 후보를
          좁혀 보여줌. "전체"는 멤버 명단과 별도로 항상 후보 목록 맨 위에 추가. */}
      {mentionSuggestions.length > 0 && (
        <View style={s.mentionList}>
          {mentionSuggestions.map(m => (
            <TouchableOpacity key={m.uid} style={s.mentionItem} onPress={() => insertMention(m.nickname)}>
              <Text style={s.mentionItemText}>@{m.nickname}</Text>
            </TouchableOpacity>
          ))}
        </View>
      )}

      <View style={s.composeRow}>
        <TextInput
          style={s.composeInput} value={message} onChangeText={handleMessageChange}
          placeholder="크루원에게 메시지 보내기 (@닉네임, @전체)" placeholderTextColor={TEXT_MUTED}
          multiline
        />
        <GradientButton label="전송" onPress={sendMessage} style={s.sendBtn} textStyle={s.sendBtnText} />
      </View>

      <ThemeRecommendModal visible={showThemeModal} onClose={() => setShowThemeModal(false)} onPick={pickTheme} uid={uid} isMinor={isMinor} />
      <EscapeShareModal visible={showEscapeModal} onClose={() => setShowEscapeModal(false)} uid={uid} crewId={crew.id} onPick={pickEscape} />
      <CrewRankingModal visible={showRankingModal} onClose={() => setShowRankingModal(false)} myCrewId={crew.id} />
    </KeyboardAvoidingView>
  );
}

// ─── 메인 ─────────────────────────────────────────────────────
export default function CrewScreen({ navigation }) {
  const { user, profile, isLoggedIn } = useAuth();
  const [crew, setCrew] = useState(null);
  const [loading, setLoading] = useState(true);
  const [myPendingCrewIds, setMyPendingCrewIds] = useState([]);
  // 79차: 탭을 빠르게 오가면 이전 포커스의 load()가 늦게 응답해 최신 상태를 오래된
  // 것으로 덮어쓸 수 있었음 — activeRef로 이전 포커스 세션의 setState만 무시.
  const activeRef = useRef(true);

  const load = useCallback(async () => {
    if (!isLoggedIn || !user?.uid) { setLoading(false); return; }
    try {
      const myCrew = await getMyCrew(user.uid);
      if (!activeRef.current) return;
      setCrew(myCrew);
      if (!myCrew) {
        const all = await listBrowsableCrews();
        if (!activeRef.current) return;
        setMyPendingCrewIds(all.filter(c => (c.pendingMemberUids || []).includes(user.uid)).map(c => c.id));
      }
    } catch { if (activeRef.current) setCrew(null); }
    finally { if (activeRef.current) setLoading(false); }
  }, [isLoggedIn, user?.uid]);

  useFocusEffect(useCallback(() => {
    activeRef.current = true;
    setLoading(true);
    load();
    // 80차 계속: 크루 탭 전용 뱃지(crewMentionBadge) 신규 도입 — 78차68차의 반복
    // 패턴("탭 진입 시 해당 타입 알림을 읽음처리 안 하면 뱃지가 영영 안 사라짐")을
    // 이번 신규 뱃지에서 재발시키지 않도록, 탭 진입 시 즉시 읽음 처리.
    if (user?.uid) markNotificationsReadByType(user.uid, ['crew_mention']).catch(() => {});
    return () => { activeRef.current = false; };
  }, [load, user?.uid]));

  const handleRequestJoin = async (crewId) => {
    if (!isLoggedIn) { navigation.navigate('Login'); return; }
    if (myPendingCrewIds.includes(crewId)) {
      await cancelJoinRequest(crewId, user.uid).catch(() => {});
      setMyPendingCrewIds(prev => prev.filter(id => id !== crewId));
      return;
    }
    try {
      await requestJoinCrew(crewId, user.uid);
      setMyPendingCrewIds(prev => [...prev, crewId]);
      showAlert('신청 완료', '크루장/관리자의 승인을 기다려주세요.');
    } catch (e) {
      showAlert('알림', e.message === 'ALREADY_IN_CREW' ? '이미 다른 크루에 가입돼 있어요.' : '가입 신청에 실패했어요.');
    }
  };

  return (
    <View style={s.container}>
      <AppHeader />
      {/* 75차: 비회원 전면 차단 제거 — 모집 게시판(75차 이전 세션)과 동일하게 둘러보기는
          열어두고, 가입 신청 등 실제 행동만 handleRequestJoin에서 로그인으로 유도 */}
      {!isLoggedIn ? (
        <BrowseCrews navigation={navigation} uid={null} myPendingCrewIds={[]} onRequestJoin={handleRequestJoin} isLoggedIn={false} />
      ) : loading ? (
        <ActivityIndicator color={GOLD} style={{ marginTop: 40 }} />
      ) : crew ? (
        <CrewHome navigation={navigation} crew={crew} uid={user.uid}
          nickname={profile?.nickname || user?.displayName || '익명'} onLeftOrChanged={load}
          blockedUsers={profile?.blockedUsers || []}
          isMinor={isConfirmedMinorBirth(profile?.birth)}
          photoURL={profile?.photoURL || user?.photoURL || null} />
      ) : (
        <BrowseCrews navigation={navigation} uid={user.uid} myPendingCrewIds={myPendingCrewIds} onRequestJoin={handleRequestJoin} />
      )}
    </View>
  );
}

const s = StyleSheet.create({
  container: { flex: 1, backgroundColor: BG },
  emptyText: { color: TEXT_MUTED, fontSize: 13, textAlign: 'center' },

  introCard: { backgroundColor: SURFACE, borderRadius: 16, borderWidth: 1, borderColor: BORDER, padding: 20, marginBottom: 24 },
  introTitle: { color: TEXT, fontSize: 18, fontWeight: '900', marginBottom: 8 },
  introDesc: { color: TEXT_SEC, fontSize: 13, lineHeight: 20, marginBottom: 16 },
  createBtn: { height: 48 },
  createBtnText: { fontSize: 14 },

  sectionLabel: { color: GOLD, fontSize: 13, fontWeight: '800', marginBottom: 10 },
  crewCard: { flexDirection: 'row', alignItems: 'center', backgroundColor: SURFACE, borderRadius: 14, borderWidth: 1, borderColor: BORDER, padding: 14, marginBottom: 10, gap: 10 },
  crewCardName: { color: TEXT, fontSize: 15, fontWeight: '800' },
  crewCardOwner: { color: TEXT_MUTED, fontSize: 11, marginTop: 2 },
  // 80차 후속: [버그 수정, 실기기 신고] lineHeight가 아예 없어서 2줄(numberOfLines={2})로
  // 보이는 설명이 "너무 붙어있어" 보였음(기본 색상 대비 자체는 정상 — WCAG 6.58:1로 확인,
  // 순수 줄간격 문제) — 1.5배 lineHeight 추가.
  crewCardDesc: { color: TEXT_SEC, fontSize: 12, lineHeight: 18, marginTop: 4 },
  crewCardMembers: { color: TEXT_MUTED, fontSize: 11, marginTop: 6 },
  // 80차 후속: [버그 수정, 실기기 신고] textMuted(#7A7A88)+10px 조합이 배경(surface2) 대비
  // 3.89:1로 WCAG AA 기준(일반 텍스트 4.5:1) 미달 — CreateCrewScreen.js의 태그 선택 칩과
  // 동일한 textSec(대비 5.92:1)로 교체, 폰트도 11로 살짝 키움.
  tagChip: { backgroundColor: SURFACE2, borderRadius: 8, paddingHorizontal: 8, paddingVertical: 4, borderWidth: 1, borderColor: BORDER },
  tagChipText: { color: TEXT_SEC, fontSize: 11 },
  tagChipActive: { borderColor: GOLD, backgroundColor: COLORS.goldBgLight },
  tagChipTextActive: { color: GOLD, fontWeight: '700' },
  joinBtn: { paddingHorizontal: 14, paddingVertical: 10 },
  joinBtnText: { fontSize: 12 },

  // 77차: 크루 배너 카드화(엠블럼 타일 추가) — design 폴더 스펙
  // 78차 66차: 3-스탯 행을 이 카드 안으로 병합(별도 카드 제거로 세로 공간 절약)
  // 80차 계속: [크기 축소] "대화창이 안 보인다"는 신고 — gap/padding/폰트/아이콘을 전부
  // 비례 축소해 카드 렌더 높이를 대략 절반 수준으로 줄임(레이아웃 구조 자체는 유지,
  // 치수만 압축). marginBottom도 6으로 줄여 바로 아래 메시지 피드와의 간격도 절약.
  crewInfoBar: { gap: 6, backgroundColor: SURFACE, borderWidth: 1, borderColor: COLORS.goldBorder, borderRadius: 14, margin: 16, marginBottom: 6, padding: 10 },
  crewEmblem: { width: 34, height: 34, borderRadius: 10, backgroundColor: GOLD, alignItems: 'center', justifyContent: 'center', overflow: 'hidden' },
  crewEmblemImg: { width: 34, height: 34 },
  crewInfoName: { color: TEXT, fontSize: 14, fontWeight: '900' },
  roleTag: { color: GOLD, fontSize: 10, fontWeight: '700' },
  crewInfoMembers: { color: TEXT_SEC, fontSize: 12, fontWeight: '700' },
  crewInfoToggle:  { color: TEXT_MUTED, fontSize: 10, flexShrink: 1 },
  crewLevelPill:   { backgroundColor: GOLD, borderRadius: 999, paddingVertical: 2, paddingHorizontal: 8 },
  crewLevelPillText: { color: '#241a06', fontSize: 11, fontWeight: '900' },
  crewCapTrack: { height: 3, borderRadius: 2, backgroundColor: 'rgba(255,255,255,0.08)', marginTop: 5, overflow: 'hidden' },
  crewCapFill:  { height: 3, borderRadius: 2, backgroundColor: GOLD },
  manageBtn: { paddingHorizontal: 9, paddingVertical: 4 },
  // 80차 계속: SecondaryButton과 동일한 톤(borderRadius/borderWidth/골드 보더)의 아이콘+라벨 버튼
  manageIconBtn: { borderRadius: 10, borderWidth: 1, borderColor: 'rgba(216,174,82,0.55)', paddingHorizontal: 9, paddingVertical: 4, alignItems: 'center', justifyContent: 'center' },
  manageIconBtnPressed: { backgroundColor: 'rgba(216,174,82,0.12)', borderColor: GOLD },
  // 80차 계속: [버그 수정] IconLabel의 Text는 SecondaryButton과 달리 자체 기본 텍스트색이
  // 없어서(전적으로 textStyle에 의존), color 없는 이 스타일을 그대로 쓰면 RN 기본값인
  // 검정으로 렌더돼 어두운 배경에 거의 안 보였음(신고 버튼도 배웠지만 이 스타일 정의
  // 자체엔 빠져있던 케이스) — "관리" 버튼(SecondaryButton, 자체 goldLight 기본색 보유)과
  // 동일한 색으로 명시.
  manageBtnText: { fontSize: 11, color: COLORS.goldLight },

  crewStatsRow: { flexDirection: 'row', alignItems: 'center', borderTopWidth: 1, borderTopColor: BORDER, paddingTop: 8, marginTop: 2 },
  crewStatItem: { flex: 1, alignItems: 'center', gap: 2 },
  crewStatValue: { color: GOLD, fontSize: 13, fontWeight: '900' },
  crewStatLabel: { color: TEXT_MUTED, fontSize: 10 },
  crewStatDivider: { width: 1, height: 20, backgroundColor: BORDER },

  postCard: { backgroundColor: SURFACE, borderWidth: 1, borderColor: BORDER, borderRadius: 14, padding: 14, marginBottom: 10 },
  noticeCard: { borderColor: COLORS.goldBorder, backgroundColor: 'rgba(216,174,82,0.06)' },
  noticeTitle: { color: TEXT, fontSize: 14, fontWeight: '800', marginBottom: 4 },
  postRow: { flexDirection: 'row', gap: 12, alignItems: 'flex-start' },
  postIconSquare: { width: 32, height: 32, borderRadius: 9, alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
  postIconText: { fontSize: 15 },
  postTypeLabel: { fontSize: 11, fontWeight: '700', marginBottom: 2 },
  postJoinPill: { backgroundColor: GOLD, borderRadius: 9, paddingHorizontal: 13, paddingVertical: 7, alignSelf: 'center' },
  postJoinPillText: { color: ON_GOLD, fontSize: 12, fontWeight: '700' },
  postMeta: { color: TEXT_MUTED, fontSize: 11, fontWeight: '700', marginBottom: 4 },
  postTime: { color: TEXT_MUTED, fontSize: 10 },
  postText: { color: TEXT, fontSize: 13, lineHeight: 19 },
  themeCardRow: { flexDirection: 'row', gap: 10, alignItems: 'center' },
  themeCardThumb: { width: 56, height: 56, borderRadius: 10, backgroundColor: SURFACE2 },
  themeCardThumbPlaceholder: { justifyContent: 'center', alignItems: 'center' },
  themeCardName: { color: TEXT, fontSize: 14, fontWeight: '800' },
  themeCardStore: { color: TEXT_MUTED, fontSize: 11 },
  themeCardGenreChip: { borderRadius: 6, borderWidth: 1, paddingHorizontal: 6, paddingVertical: 1 },
  themeCardGenreText: { fontSize: 10, fontWeight: '700' },
  themeCardPrice: { color: GOLD, fontSize: 12, fontWeight: '700' },

  quickActionsRow: { flexDirection: 'row', gap: 8, paddingHorizontal: 16, paddingBottom: 8 },
  quickActionBtn: {
    flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: 6,
    paddingVertical: 8, borderRadius: 12, borderWidth: 1,
  },
  quickActionGold: { backgroundColor: 'rgba(216,174,82,0.10)', borderColor: COLORS.gold + '55' },
  quickActionGoldPressed: { backgroundColor: 'rgba(216,174,82,0.18)' },
  quickActionGreen: { backgroundColor: COLORS.successBg, borderColor: COLORS.greenBorder },
  quickActionGreenPressed: { backgroundColor: 'rgba(111,191,142,0.20)' },
  quickActionText: { fontSize: 12, fontWeight: '700' },

  // 80차 계속: @멘션 자동완성 후보 목록 — composeRow 바로 위, 가로 스크롤 칩 형태
  mentionList: { flexDirection: 'row', flexWrap: 'wrap', gap: 6, paddingHorizontal: 12, paddingVertical: 8, backgroundColor: SURFACE, borderTopWidth: 1, borderTopColor: BORDER },
  mentionItem: { backgroundColor: COLORS.goldBg, borderWidth: 1, borderColor: COLORS.goldBorder, borderRadius: 14, paddingHorizontal: 10, paddingVertical: 5 },
  mentionItemText: { color: GOLD, fontSize: 12, fontWeight: '700' },
  composeRow: { flexDirection: 'row', alignItems: 'flex-end', gap: 8, padding: 12, borderTopWidth: 1, borderTopColor: BORDER, backgroundColor: SURFACE },
  composeInput: { flex: 1, backgroundColor: SURFACE2, borderRadius: 10, borderWidth: 1, borderColor: BORDER, paddingHorizontal: 12, paddingVertical: 8, color: TEXT, fontSize: 13, maxHeight: 100 },
  sendBtn: { paddingHorizontal: 16, paddingVertical: 10 },
  sendBtnText: { fontSize: 13 },

  modalBackdrop: { flex: 1, backgroundColor: 'rgba(0,0,0,0.6)', justifyContent: 'flex-end' },
  modalSheet: { backgroundColor: SURFACE, borderTopLeftRadius: 20, borderTopRightRadius: 20, padding: 20, maxHeight: '80%' },
  modalSheetTall: { height: '55%' },
  modalTitle: { color: TEXT, fontSize: 16, fontWeight: '900', marginBottom: 12 },
  modalSectionLabel: { color: TEXT_MUTED, fontSize: 11, fontWeight: '700', marginBottom: 8 },
  modalInput: { backgroundColor: SURFACE2, borderRadius: 10, borderWidth: 1, borderColor: BORDER, paddingHorizontal: 12, height: 44, color: TEXT, fontSize: 13, marginBottom: 12 },
  modalResultRow: { paddingVertical: 10, borderBottomWidth: 1, borderBottomColor: BORDER },
  modalResultName: { color: TEXT, fontSize: 14, fontWeight: '700' },
  modalResultStore: { color: TEXT_MUTED, fontSize: 11, marginTop: 2 },
  confirmThemeRow: { flexDirection: 'row', gap: 10, alignItems: 'center', backgroundColor: SURFACE2, borderRadius: 12, padding: 12, marginTop: 4 },
  escapePreviewCard: { backgroundColor: SURFACE2, borderRadius: 12, padding: 14, marginTop: 4 },
});
